import {
  ChartComponentParams,
  InstanceData,
  InstanceDataPoint,
} from "@/types/chart";
import { ChartData } from "chart.js";
import dayjs from "dayjs";

const colorSet = [
  "#0569A2",
  "#E9D8A6",
  "#F54C87",
  "#BC94AC",
  "#70CA63",
  "#E9573F",
  "#36BC9B",
  "#926DDE",
  "#BC94AC",
  "#184E74",
];

export const convertInstanceDataToChartData = ({
  chartType,
  instanceData,
  instanceLabels,
  timeFrame,
  range,
}: Pick<
  ChartComponentParams,
  "chartType" | "instanceData" | "instanceLabels" | "timeFrame" | "range"
>): ChartData<"bar" | "line"> | null => {
  if (!["bar", "line"].includes(chartType))
    throw new Error("Invalid chart type");

  if (
    !instanceData ||
    instanceData.length === 0 ||
    !instanceLabels ||
    instanceLabels.length === 0 ||
    !timeFrame ||
    !range
  ) {
    console.error("Invalid instance data, labels, timeFrame, or range");
    return { labels: [], datasets: [] };
  }

  const getDataForTimeFrameAndRange = (
    data: InstanceData
  ): InstanceDataPoint[] => {
    return data[range]?.[timeFrame] || [];
  };
  const labels = Array.from(
    new Set(
      instanceData.flatMap((data) =>
        getDataForTimeFrameAndRange(data).map((d) =>
          dayjs(d.time).format("YYYY-MM-DD")
        )
      )
    )
  ).sort();

  const datasets = instanceData.map((data, index) => {
    const dataPoints = getDataForTimeFrameAndRange(data);
    return {
      label: instanceLabels[index],
      data: labels.map((label) => {
        const dataPoint = dataPoints.find(
          (d) => dayjs(d.time).format("YYYY-MM-DD") === label
        );
        return dataPoint ? +dataPoint.value : null;
      }),
      backgroundColor: colorSet[index % colorSet.length],
      borderColor: colorSet[index % colorSet.length],
      borderWidth: chartType === "bar" ? 0 : 3,
      spanGaps: true,
    };
  });

  return { labels, datasets };
};
